import 'bootstrap'
import 'admin-lte'
import 'bootstrap/dist/css/bootstrap.css'
import 'admin-lte/dist/css/AdminLTE.min.css'
import 'admin-lte/dist/css/skins/skin-blue-light.min.css'
import 'admin-lte/dist/css/skins/skin-red-light.min.css'
import 'admin-lte/dist/css/skins/skin-yellow-light.min.css'
import 'admin-lte/dist/css/skins/skin-green-light.min.css'
import 'admin-lte/dist/css/skins/skin-purple-light.min.css'

import '@/css/custom.css'

import Vue from 'vue'
import router from '@/router'
import App from '@/App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from '@/store'
import VueCollapse from 'vue2-collapse'
import { i18n } from '@/lib/i18n.js'

// CSP対策でインラインスタイルを禁止し、別途CSSを読み込むようにする
import { config } from '@fortawesome/fontawesome-svg-core'
config.autoAddCss = false
import '@fortawesome/fontawesome-svg-core/styles.css'
import '@fortawesome/fontawesome-free/js/fontawesome'
import '@fortawesome/fontawesome-free/js/solid'
import '@fortawesome/fontawesome-free/js/regular'
import '@fortawesome/fontawesome-free/js/brands'

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.use(VueCollapse)

var ignoreList = [
  'beforeDestroy hook', //errorHandler info
  'ResizeObserver loop limit exceeded', //addEventListener.error event.message
]

// エラー情報送信
Vue.config.errorHandler = (err, vm, info) => {
  if (checkIgnore(info)) return
  var errObj = {
    name: err.name,
    message: err.message,
    stack: err.stack
  }
  sendError({
    capturer: 'Vue.config.errorHandler',
    info: info,
    err: errObj
  })
  console.log(`Captured in Vue.config.errorHandler: ${info}`, err)
}
Vue.config.warnHandler = (msg, vm, trace) => {
  if (checkIgnore(msg)) return
  sendError({
    capturer: 'Vue.config.warnHandler',
    msg: msg,
    trace: trace
  })
  console.log(`Captured in Vue.config.warnHandler\n${msg}${trace}`)
}
window.addEventListener('error', event => {
  if (checkIgnore(event.message)) return
  sendError({
    capturer: 'window.addEventListener.error',
    err: event.message,
    info: { url: location.href },
  })
  console.log('Captured in error EventListener', event.message)
})
window.addEventListener('unhandledrejection', event => {
  if (checkIgnore(event.reason)) return

  const reason = { message: JSON.stringify(event.reason) }
  if (event.reason instanceof Error) {
    reason.message = event.reason.message
    reason.name = event.reason.name
    reason.stack = event.reason.stack
  }
  sendError({
    capturer: 'window.addEventListener.unhandledrejection',
    reason: reason,
    info: { url: location.href },
  })
  console.log('Captured in unhandledrejection EventListener', event.reason)
})

const sendError = (err) =>{
  store.dispatch('auth/sendError',err)
}

const checkIgnore = (target) => {
  return ignoreList.includes(target)
}

Vue.config.devtools=true
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render(createElement) {
    return createElement(App)
  },
})
